import { gql } from '@/clients/utoniq-core'

export const fragments = {
  consoleMyProfile: gql`
    fragment ConsoleMyProfileConnection on Artist {
      id
      accountId
      formattedAccountId @client
      avatar {
        uri
        smallUri
        mediumUri
        compressedUri
      }
      displayName
      introduction
      sns {
        twitter
        tiktok
        instagram
        facebook
        youtube
      }
      profileText
      textLink {
        content
        uri
      }
    }
  `,
} as const
